import firebase from 'firebase/app'
import 'firebase/firestore'
import 'firebase/auth'

// const firebaseConfig = {
//   apiKey: "AIzaSyDHHsqOUPNcwXZQKY750IlMt7ZbBA2Ifng",
//   authDomain: "myjoke-66907.firebaseapp.com",
//   projectId: "myjoke-66907",
//   storageBucket: "myjoke-66907.firebasestorage.app",
//   messagingSenderId: "282848695486",
//   appId: "1:282848695486:web:57e802fe2b0d00a08afaef"
// };

// const firebaseConfig = {
//   apiKey: "AIzaSyCMpglxfF-zK3zHZaOq2fOE14VWw7EuSBE",
//   authDomain: "recipe-project-65c70.firebaseapp.com",
//   projectId: "recipe-project-65c70",
//   storageBucket: "recipe-project-65c70.firebasestorage.app",
//   messagingSenderId: "564029850032",
//   appId: "1:564029850032:web:097db98d5e909f5b8ed675"
// };

const firebaseConfig = {
  apiKey: "AIzaSyBW7JwGM44ssUEwwkOv3mgBXPwYPmJ5o8o",
  authDomain: "polhok-f98ce.firebaseapp.com",
  projectId: "polhok-f98ce",
  storageBucket: "polhok-f98ce.firebasestorage.app",
  messagingSenderId: "7035234187",
  appId: "1:7035234187:web:f65a4d3bd45fd4625e318e"
};

// init firebase
firebase.initializeApp(firebaseConfig)

// init services
const projectFirestore = firebase.firestore()
const projectAuth = firebase.auth()

// timestamp
const timestamp = firebase.firestore.Timestamp

export { projectFirestore, projectAuth, timestamp }